
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iVLlf", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $e1Stz = parcelRequire("e1Stz");


var $e4o8D = parcelRequire("e4o8D");


var $2w2Hu = parcelRequire("2w2Hu");

var $3GQl6 = parcelRequire("3GQl6");


var $6gj4X = parcelRequire("6gj4X");

const $c7439796c701ccec$export$53c6ffd7d2d07a9a = (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { macroDefaultProps: macroDefaultProps, macroParams: macroParams, openAnchorsInNewTab: openAnchorsInNewTab, Renderer: Renderer, isLegacyRenderer: isLegacyRenderer } = t0;
    (0, $3GQl6.mustPreloadWhenRenderingSPA)([
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicRendererLoader,
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicEditorContextProviderLoader
    ]);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t1;
    if ($[0] !== macroDefaultProps.node) {
        t1 = (0, $6gj4X.getMacroId)(macroDefaultProps.node);
        $[0] = macroDefaultProps.node;
        $[1] = t1;
    } else t1 = $[1];
    const macroId = t1;
    const t2 = macroDefaultProps.attributes?.macroId || macroId;
    let t3;
    if ($[2] !== macroDefaultProps.attributes || $[3] !== t2) {
        t3 = {
            ...macroDefaultProps.attributes,
            macroId: t2
        };
        $[2] = macroDefaultProps.attributes;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== macroDefaultProps || $[6] !== t3) {
        t4 = {
            ...macroDefaultProps,
            attributes: t3
        };
        $[5] = macroDefaultProps;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const macroDefaultPropsWithMacroId = t4;
    let t5;
    if ($[8] !== macroId || $[9] !== renderServerPlaceholder) {
        t5 = renderServerPlaceholder ? {
            "data-ssr-placeholder": macroId
        } : {
            "data-ssr-placeholder-replace": macroId
        };
        $[8] = macroId;
        $[9] = renderServerPlaceholder;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== Renderer || $[12] !== isLegacyRenderer || $[13] !== macroDefaultPropsWithMacroId || $[14] !== macroParams || $[15] !== openAnchorsInNewTab) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e1Stz.PagePropertiesReportRenderer), {
            macroDefaultProps: macroDefaultPropsWithMacroId,
            macroParams: macroParams,
            openAnchorsInNewTab: openAnchorsInNewTab,
            Renderer: Renderer,
            isLegacyRenderer: isLegacyRenderer
        });
        $[11] = Renderer;
        $[12] = isLegacyRenderer;
        $[13] = macroDefaultPropsWithMacroId;
        $[14] = macroParams;
        $[15] = openAnchorsInNewTab;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== macroId || $[18] !== t5 || $[19] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-fabric-macro": macroId,
            "data-vc": "page-properties-report-macro",
            ...t5
        }, t6);
        $[17] = macroId;
        $[18] = t5;
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
};
module.exports["DetailsSummaryExtensionHandler"] = $c7439796c701ccec$export$53c6ffd7d2d07a9a;

});

parcelRegister("e1Stz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36f7db2a9cac59c0$export$7cf7439e5d7797c5 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ymRP0",
    name: "PagePropertiesReportRenderer",
    loader: async ()=>(await (parcelRequire("eznY0"))).PagePropertiesReportRenderer
});
module.exports["PagePropertiesReportRenderer"] = $36f7db2a9cac59c0$export$7cf7439e5d7797c5;

});

parcelRegister("eznY0", function(module, exports) {

let $a9b6ecdddfbcbefe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a9b6ecdddfbcbefe$var$load("ilUG7"),
    $a9b6ecdddfbcbefe$var$load("efUj2"),
    $a9b6ecdddfbcbefe$var$load("gaT5l"),
    $a9b6ecdddfbcbefe$var$load("2Vm3g"),
    $a9b6ecdddfbcbefe$var$load("6wr18"),
    $a9b6ecdddfbcbefe$var$load("hhss7"),
    $a9b6ecdddfbcbefe$var$load("ffEVr"),
    $a9b6ecdddfbcbefe$var$load("dnwTC")
]).then(()=>parcelRequire('3Jp28'));

});

parcelRegister("6gj4X", function(module, exports) {
const $45b144f792a5212a$export$36b5af56b86b89d3 = (isLegacyRenderer, rendererProps)=>{
    if (!isLegacyRenderer) return rendererProps;
    return {
        adf: rendererProps.document,
        objectId: rendererProps.contentId,
        contentType: rendererProps.contentType
    };
};
const $45b144f792a5212a$export$47eae2202f029f6b = (node)=>node?.parameters?.macroMetadata?.macroId?.value;
module.exports["convertRendererProps"] = $45b144f792a5212a$export$36b5af56b86b89d3;
module.exports["getMacroId"] = $45b144f792a5212a$export$47eae2202f029f6b;

});

parcelRegister("ZJvdP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $543e3a9ad9cfc398$export$3ad73c971369d052 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sYDyD",
    name: "PageIncludeMacroHandler",
    loader: async ()=>(await (parcelRequire("gIDv4"))).PageIncludeMacroRenderer
});
module.exports["PageIncludeMacroHandler"] = $543e3a9ad9cfc398$export$3ad73c971369d052;

});

parcelRegister("gIDv4", function(module, exports) {

let $c2bf65516d0474fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c2bf65516d0474fe$var$load("5h4De").then(()=>parcelRequire('doY9Y'));

});

parcelRegister("8Ksv7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $11414ac1857ca883$export$cfa4ed6e2f4ad26 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "lJE6O",
    name: "BlogPostsMacroHandler",
    loader: async ()=>(await (parcelRequire("9a78C"))).BlogPostsMacroRenderer
});
module.exports["BlogPostsMacroHandler"] = $11414ac1857ca883$export$cfa4ed6e2f4ad26;

});

parcelRegister("9a78C", function(module, exports) {

let $6aba95b566081bd5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6aba95b566081bd5$var$load("7jwjb"),
    $6aba95b566081bd5$var$load("cenKA"),
    $6aba95b566081bd5$var$load("1GCFv"),
    $6aba95b566081bd5$var$load("dZsGY"),
    $6aba95b566081bd5$var$load("bV5bW"),
    $6aba95b566081bd5$var$load("28h7Y")
]).then(()=>parcelRequire('5iRsI'));

});


//# sourceMappingURL=DetailsSummaryExtensionHandler.80a0f8f6.js.map
